import { ActionHandler } from 'action-handler';

export const STATE_PROP = 'osPermissions';

export default new ActionHandler({
  name: 'set_os_permission',
  defaultState: {
    [STATE_PROP]: {}
  },
  handler: (permissionType, permissionStatus) => ({
    permissionType,
    permissionStatus
  }),
  reduce(state, { permissionType, permissionStatus }) {
    return {
      [STATE_PROP]: {
        ...state[STATE_PROP],
        [permissionType]: permissionStatus
      }
    };
  }
});
